import classNames from 'classnames';
import { forwardRef } from 'react';
import { Tooltip as BootstrapTooltip } from 'react-bootstrap';

import styles from './_index.module.scss';

interface TooltipProps {
  children: React.ReactNode;
  className?: string;
  isFullWidth?: boolean;
}

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, className, isFullWidth, ...props }, ref) => {
    return (
      <BootstrapTooltip
        className={classNames(
          styles['tooltip'],
          {
            [styles['is-full-width']]: isFullWidth,
          },
          className
        )}
        {...props}
        ref={ref}
      >
        {children}
      </BootstrapTooltip>
    );
  }
);

export default Tooltip;
